import { FC, PropsWithChildren, useContext } from 'react';
import { StageCollectionResponse } from '../../api/dtos';
import ProjectContext from '../../contexts/data/ProjectContext';

import StagesContext from '../../contexts/data/StagesContext';
import useStagesByProjectId from '../../hooks/data/useStagesByProjectId';


export interface IStagesProviderProps {
    initial?: StageCollectionResponse;
}

export const StagesProvider: FC<PropsWithChildren<IStagesProviderProps>> = ({ initial, children }) => {
    const { data: project } = useContext(ProjectContext);
    const stages = useStagesByProjectId(
        project ? project.id : undefined,
        undefined,
        undefined,
        { revalidateOnFocus: false, fallbackData: initial}
    );

    return (
        <StagesContext.Provider value={stages}>
            {children}
        </StagesContext.Provider>
    );
}

export default StagesProvider;
